export default __webpack_public_path__ + "static/media/kløfthammer.f972d030.svg";